import { Component, inject, LOCALE_ID } from '@angular/core';
import { RouterModule } from '@angular/router';

import { GoogleAnalyticsEventsService } from '../../../services/google-analytics-events.service';
import { IcortexLocalizedPathService } from '../../../services/icortex-localized-path.service';
import { IcortexWhatsappLinkService } from '../../../services/icortex-whatsapp-link.service';

/** Calendly: solo build `es` (CTA secundario del banner). */
const CTA_SECONDARY_CALENDLY_URL = 'https://calendly.com/icortex/asesoria-estrategica-icortex';

@Component({
  standalone: true,
  selector: 'app-wf-cta-banner',
  imports: [ RouterModule ],
  templateUrl: './wf-cta-banner.component.html'
})
export class WfCtaBannerComponent {

  private readonly googleAnalyticsEventsService = inject( GoogleAnalyticsEventsService );

  private readonly icortexWhatsappLinkService = inject( IcortexWhatsappLinkService );

  private readonly icortexLocalizedPathService = inject( IcortexLocalizedPathService );

  private readonly localeId = inject( LOCALE_ID );

  protected readonly signupHref = this.icortexLocalizedPathService.getLocalizedPath( '/signup' );

  /**
   * @description Enlace del CTA secundario: Calendly solo para español; WhatsApp con `text` localizado en en-US, pt, ko.
   */
  protected readonly secondaryCtaHref = this.localeId === 'es'
    ? CTA_SECONDARY_CALENDLY_URL
    : this.icortexWhatsappLinkService.getExpertWhatsappWebUrl();

  sendGAEvent( category: string, action: string, label: string, value?: number ): void {

    this.googleAnalyticsEventsService.emitEvent( category, action, label, value );
  }

}
